// src/components/Header.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import { useAppContext } from '../context/AppContext';
import fhiLogo from '../assets/fhi-logo-white.png';

function ContextChip({ label, value }) {
  if (!value) return null;
  return (
    <div className="app-header__context-chip">
      {label}: <span>{value}</span>
    </div>
  );
}

export default function Header() {
  const { signOut }             = useAuth();
  const { user, selection }     = useAppContext();
  const navigate                = useNavigate();

  const formatDate = (d) => {
    if (!d) return null;
    const [year, month, day] = d.split('-');
    return new Date(year, month - 1, day).toLocaleDateString('en-US', {
      month: 'short', day: 'numeric', year: 'numeric'
    });
  };

  return (
    <header className="app-header">
      <div className="app-header__brand" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
        <img src={fhiLogo} alt="FHI" className="app-header__logo" />
      </div>

      {selection && (
        <div className="app-header__context">
          <ContextChip label="Facility"   value={selection.facility?.strName} />
          <ContextChip label="Department" value={selection.department?.strName} />
          <ContextChip label="Shift"      value={selection.shift?.strName} />
          <ContextChip label="Date"       value={formatDate(selection.shiftDate)} />
        </div>
      )}

      <div className="app-header__right">
        {user && (
          <div className="user-info">
            <div style={{ fontWeight: 600, color: 'white' }}>{user.displayName}</div>
            <div style={{ fontSize: '.72rem', color: 'rgba(255,255,255,.7)' }}>
              ID: {user.associateId}
            </div>
          </div>
        )}
        <button className="btn btn-ghost btn-sm" onClick={signOut}>
          ⎋ Sign Out
        </button>
      </div>
    </header>
  );
}
